import { isString } from 'lodash-es';

export function trimSoftHyphen(str: string) {
  if (!isString(str)) {
    return str;
  }

  return str.replace(/\u00AD/g, '');
}
